module.exports = __webpack_public_path__ + "img/city_share_icon.bd50e32e.png";